import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Radium from 'radium';
import DesktopRenderer from './DesktopRenderer';
import shallowEqual from 'fbjs/lib/shallowEqual';
import { getNormalizedStaticDesktopElements, getNormalizedDesktopElementsForRenderWithDragPosition } from 'crazyEditor/redux/modules/element/elementSelectors';
import { getElementDefinitionProps } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { getDesktopDOMNodeById } from 'crazyEditor/core/elements/utils/elementRefUtils';
import { updateMeasuredSizes } from 'crazyEditor/redux/modules/element/actions/elementLayoutActions';
import { setSelectedElementIds } from 'crazyEditor/redux/modules/stage/stage';
import { PAGE_ELEMENT_ID } from 'crazyEditor/core/elements/utils/elementStaticUtils';
import { elementTypes } from 'crazyEditor/components/Elements/index';
import {getCrossSellGalleryItemsIds} from 'crazyEditor/components/Elements/CrossSellGalleryElement/CrossSellGalleryHelper';

import sharedStyles from '../SharedViewStyles';
import styles from './DesktopViewStyles';

@connect(
  (state) => ({
    isWhiteLabel: state.user.isWhiteLabel,
    desktopElements: getNormalizedDesktopElementsForRenderWithDragPosition(state),
    staticDesktopElements: getNormalizedStaticDesktopElements(state),
    measuredSizes: state.element.present.measuredSizes,
    isDraggingElement: state.stage.isDraggingElement,
    autoHeightTextElement: state.user.autoHeightTextElement,
    isQuickPreviewMode: state.editor.isQuickPreviewMode,
    itemId: _.get(state.listingData, 'itemID'),
  }),
  {updateMeasuredSizes, setSelectedElementIds}
)
@Radium
export default class DesktopView extends Component {

  componentWillMount() {
    const {desktopElements, itemId} = this.props;
    document.querySelector('html').style.overflowY = 'scroll';
    const crossSellGalleryElements = _.filter(desktopElements, (element) => element.type === elementTypes.CrossSellGalleryElement);
    _.forEach(crossSellGalleryElements, (crossSellGalleryElement) => getCrossSellGalleryItemsIds(crossSellGalleryElement.data.sellerId, crossSellGalleryElement.data.globalId, itemId));
  }

  componentDidMount() {
    const { setSelectedElementIds, updateMeasuredSizes } = this.props;
    setSelectedElementIds(PAGE_ELEMENT_ID);
    updateMeasuredSizes(this.getMeasuredSizes(this.props));
  }

  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps) && (this.props.isVisible || nextProps.isVisible);
  }

  componentDidUpdate(prevProps) {
    const { desktopElements, updateMeasuredSizes, isDraggingElement} = this.props;
    const prevMeasuredSizes = this.props.measuredSizes;
    if (!isDraggingElement && prevProps.desktopElements !== desktopElements) {
      const measuredSizes = this.getMeasuredSizes(this.props);
      if ((!(_.isEmpty(prevMeasuredSizes) && _.isEmpty(measuredSizes))) && !_.isEqual(prevMeasuredSizes, measuredSizes)) {
        _.defer(updateMeasuredSizes, measuredSizes);
      }
    }
  }

  componentWillUnmount() {
    document.querySelector('html').style.overflowY = '';
  }

  getMeasuredSizes(props) {
    const {desktopElements} = props;
    const measuredSizes = [];
    _.filter(desktopElements, (element) => {
      const elementDefinitionProps = getElementDefinitionProps(element);
      return elementDefinitionProps.autoHeight || elementDefinitionProps.fullWidth;
    }).forEach((element) => {
      const elementDOMNode = getDesktopDOMNodeById(element.id);
      const elementDefinitionProps = getElementDefinitionProps(element);
      if (elementDOMNode && elementDOMNode.offsetHeight) {
        const elementUpdate = {
          id: element.id,
          layout: {}
        };
        if (elementDefinitionProps.autoHeight) {
          elementUpdate.layout.height = elementDOMNode.offsetHeight;
        }
        if (elementDefinitionProps.fullWidth) {
          elementUpdate.layout.width = elementDOMNode.offsetWidth;
        }
        measuredSizes.push(elementUpdate);
      }
    });
    return measuredSizes;
  }

  getContainerStyles() {
    const { isVisible } = this.props;
    return [
      isVisible && sharedStyles.visible,
      !isVisible && sharedStyles.hidden
    ];
  }

  shouldShowAds() {
    const { isPreviewMode, isWhiteLabel } = this.props;
    return isPreviewMode && !isWhiteLabel;
  }

  render() {
    const { desktopElements, staticDesktopElements, isPreviewMode, autoHeightTextElement, isQuickPreviewMode} = this.props;

    return (
      <div style={this.getContainerStyles()}>
        <DesktopRenderer
          viewStyles={styles.desktopView}
          desktopElements={desktopElements}
          staticDesktopElements={staticDesktopElements}
          showAds={this.shouldShowAds()}
          isPreviewMode={isPreviewMode}
          autoHeightTextElement = {autoHeightTextElement}
          isQuickPreviewMode = {isQuickPreviewMode}
        />
      </div>
    );
  }
}

DesktopView.propTypes = {
  isVisible: PropTypes.bool,
  isPreviewMode: PropTypes.bool
};